<template>
  <div class="multi-search-input flexC mr-8">
    <div v-if="config.title" class="option-title  mr-6">
      {{ config.title }}
    </div>
    <cube-input ref="input" v-model.trim="form.value"  clearable  class="mr-8" v-bind="config"  @clear="clear" />
    <div>
      <cube-button :disabled="!form.value"  plain @click="confirm">确定</cube-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    parent: {
      type: Object,
      default: () => { return {} }
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      form: {
        value: ''
      }
    }
  },
  computed: {
    config() {
      return this.parent.config ? this.parent.config : {}
    }
  },
  methods: {
    clear() {
      this.$emit('clear', 'input')
    },
    reset() {
      this.form.value = ''
    },
    confirm() {
      if (!this.form.value) return
      const v = this.form.value.trim()
      this.$emit('confirm', this.parent, { label: v, value: v }, 'input')
      // this.form.value = ''
      // this.option = null
    }
  }
}
</script>
<style lang="scss" scoped>
.option-title{
  font-size: 14px;
  white-space: nowrap;
  color: #686F80;
}
</style>
